import { css } from '@emotion/core';

export const productImageCss = (theme) => css`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  object-fit: contain;
  border: 2px solid ${theme.getColor('primary')};
`;
